import { render, staticRenderFns } from "./DuctlessSolutions.vue?vue&type=template&id=6ca04d99&scoped=true&"
var script = {}
import style0 from "./DuctlessSolutions.vue?vue&type=style&index=0&id=6ca04d99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca04d99",
  null
  
)

export default component.exports